import { useState } from 'react'
import { toast } from 'react-toastify'

import { patientProfilesApi } from '../api/services/dd_panel_patient_profiles'
import { PatientProfile } from '../api/services/orders/types.ts'
import { patientTypesAPI } from '../api/services/patient_types'
import { PatientType } from '../api/services/patient_types/types.ts'

const usePatientProfile = () => {
  const [profile, setProfile] = useState<PatientProfile | null>(null)
  const [profileTypes, setProfileTypes] = useState<PatientType[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  const getPatientTypes = async () => {
    const response = await patientTypesAPI.getPatientTypes<PatientType[]>()

    if (response.error) {
      setError(response.error)
    }
    if (response.status !== 200) {
      toast.loading(response.error, {
        type: 'error',
        delay: 100,
        isLoading: false,
        autoClose: 2000
      })
      return
    }

    setProfileTypes(response.data)
  }

  const getPatientProfile = async (patientProfileId: number) => {
    if (patientProfileId) {
      const response = await patientProfilesApi.getDetails<PatientProfile>(
        Number(patientProfileId)
      )

      if (response.error) {
        setError(response.error)
      }
      if (response.status !== 200) {
        toast.loading(response.error, {
          type: 'error',
          delay: 100,
          isLoading: false,
          autoClose: 3000
        })
        return
      }

      setProfile(response.data)
    }
  }

  const createPatient = async (data: PatientProfile) => {
    const response =
      await patientProfilesApi.createProfile<PatientProfile>(data)

    if (response.error) {
      setError(response.error)
    }
    if (response.status !== 201) {
      toast.loading(response.error, {
        type: 'error',
        delay: 100,
        isLoading: false,
        autoClose: 2000
      })
    }
    return response.data
  }

  return {
    profileTypes,
    profile,
    getPatientTypes,
    getPatientProfile,
    createPatient,
    error
  }
}

export default usePatientProfile
